module.exports = __webpack_public_path__ + "img/gu.f7e1c6de.svg";